import { render, staticRenderFns } from "./addUpdTaak.vue?vue&type=template&id=651cbde9&scoped=true"
import script from "./addUpdTaak.vue?vue&type=script&lang=js"
export * from "./addUpdTaak.vue?vue&type=script&lang=js"
import style0 from "./addUpdTaak.vue?vue&type=style&index=0&id=651cbde9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651cbde9",
  null
  
)

export default component.exports